import * as moment from "moment";

import { OrgStructure } from "@teamprevent/common/orgStructure/models";

import * as actions from "./actionTypes";
import { OrgStructureAction } from "./actions";

export function orgStructures(state: OrgStructure[] = [], action: OrgStructureAction): OrgStructure[] {
    switch (action.type) {
        case actions.LOAD_ORGSTRUCTURES_SUCCESS:
            const newOrgStructures = action.payload.filter(orgLevel => !state.find(l => l.id === orgLevel.id));
            return [...state, ...newOrgStructures].map(org => ({ ...org, listUpdated: moment() }));
        case actions.CLEAR_ORGSTRUCTURES:
            return [];
        default:
            return state;
    }
}
